import { HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';

 export class FileHelper {
    public static saveFile(response: HttpResponse<Blob>) {
        const disposition = response.headers.get('Content-Disposition');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        FileSaver.saveAs(response.body, filename);
    }
}
